import secureLs from '@/libs/secureLs'

export default {
  namespaced: true,
  state: {
    userData: secureLs.getItem('userData') ? secureLs.getItem('userData') : {},
    ktpVerificationStatus: null,
    pinCreatedStatus: null,
  },
  mutations: {
    UPDATE_USER_DATA(state, val) {
      state.userData = val
    },
    SET_KTP_VERIFICATION_SUCCESS(state, val) {
      state.ktpVerificationStatus = val
    },
    SET_PIN_CREATED_SUCCESS(state, val) {
      state.pinCreatedStatus = val
    },
  },
  actions: {},
}
